interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}>
      <span
        className={`inline-flex items-center gap-2 text-xs md:text-sm font-semibold tracking-wide text-primary-700 ${
          isCenter ? "justify-center" : ""
        }`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
        {title}
      </h2>
      {description ? (
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:mt-4 md:text-base">
          {description}
        </p>
      ) : null}
    </div>
  );
}